import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'asciiCheck'
})
export class AsciiCheckPipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {

  }
  transform(html: string): SafeHtml {
    const convertedString = html && html.length ?
      html.replace(/&#60/g, '<').replace(/&#62/g, '>') : html;
    return this.domSanitizer.bypassSecurityTrustHtml(convertedString);
  }
}
